var _path, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSend(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.2148 0.5H30.7998C38.3743 0.500134 44.5145 6.6404 44.5146 14.2148V30.7998C44.5145 38.3743 38.3743 44.5145 30.7998 44.5146H14.2148C6.6404 44.5145 0.500134 38.3743 0.5 30.7998V14.2148C0.500182 6.64043 6.64043 0.500182 14.2148 0.5Z",
    fill: "url(#paint0_linear_60_15133)",
    stroke: "url(#paint1_linear_60_15133)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_60_15133)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.3687 13.7817L10.6124 16.5012C9.73799 16.6158 9.01538 17.2047 8.72656 18.0379C8.43779 18.8712 8.64103 19.781 9.25703 20.4121L14.122 25.3964L21.4193 21.1833C21.7551 20.9894 22.1846 21.1045 22.3785 21.4403C22.5723 21.7761 22.4573 22.2055 22.1215 22.3994L14.8241 26.6125L16.7082 33.3178C16.9467 34.1669 17.6329 34.7978 18.499 34.9643C19.3668 35.1312 20.2373 34.7982 20.7728 34.0994L33.5061 17.4838C34.0859 16.7273 34.1499 15.7446 33.6734 14.9192C33.1968 14.0937 32.3137 13.6578 31.3687 13.7817Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_60_15133",
    x1: 5.96212,
    y1: 1.21049,
    x2: 52.7843,
    y2: 90.5651,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A464F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.326923,
    stopColor: "#A109DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.701923,
    stopColor: "#1E31DD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.999382,
    stopColor: "#441B6E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_60_15133",
    x1: 5.394,
    y1: -8.57964e-7,
    x2: 49.7111,
    y2: 39.7831,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9747FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1E31DD"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_60_15133"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 23.9646,
    height: 23.9646,
    fill: "white",
    transform: "translate(6.92969 16.5244) rotate(-30)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSend);
export default __webpack_public_path__ + "static/media/send.537cd45bedcb0e2973c4edae1b2c8fc1.svg";
export { ForwardRef as ReactComponent };